import { render, staticRenderFns } from "./TaxationContent.vue?vue&type=template&id=b1ac2234&scoped=true&"
import script from "./TaxationContent.vue?vue&type=script&lang=js&"
export * from "./TaxationContent.vue?vue&type=script&lang=js&"
import style0 from "./TaxationContent.vue?vue&type=style&index=0&id=b1ac2234&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ac2234",
  null
  
)

export default component.exports